import { summarizeAssistantValue } from 'ai-assistant/utils/summarizeAssistantValue';
import { AssistantContextSnapshot } from './AssistantContext';

const MAX_SERIALIZED_LENGTH = 2000;

const truncate = (value: string, maxLength?: number | null): string => {
  if (maxLength === null) {
    return value;
  }

  const resolvedMaxLength = typeof maxLength === 'number' ? maxLength : MAX_SERIALIZED_LENGTH;
  if (value.length <= resolvedMaxLength) {
    return value;
  }
  return `${value.slice(0, resolvedMaxLength)}…`;
};

const serializeData = (data: unknown): string => {
  try {
    return JSON.stringify(data, null, 2);
  } catch (error) {
    return `"[unserializable data: ${(error as Error).message}]"`;
  }
};

export const formatAssistantContext = (snapshot: AssistantContextSnapshot): string => {
  const entries = Object.entries(snapshot);

  if (entries.length === 0) {
    return '';
  }

  return entries
    .map(([key, entry]) => {
      const summary = entry.summary.trim();
      const baseLine = `${key}: ${summary}`;
      const detailsLine = entry.data === undefined
        ? null
        : `details: ${truncate(serializeData(summarizeAssistantValue(entry.data)), entry.maxSerializedLength)}`;
      const sourceLine = entry.source ? `source: ${entry.source}` : null;

      return [baseLine, detailsLine, sourceLine]
        .filter((segment): segment is string => Boolean(segment))
        .join('\n');
    })
    .join('\n\n');
};


